/**
 * 全局公告弹窗宿主：H5 挂到 body，任意页面可弹出（不依赖 layout / 首页）。
 */
import { createApp, h, type Plugin } from 'vue';
import type { Pinia } from 'pinia';
import AnnouncementModal from '@/components/announcement-modal/index.vue';

let hostMounted = false;

export const isAnnouncementHostMounted = () => hostMounted;

function ensureAnnouncementHost(pinia: Pinia, i18n: Plugin) {
  if (hostMounted || typeof document === 'undefined') return;
  if (document.getElementById('app-announcement-root')) {
    hostMounted = true;
    return;
  }

  const el = document.createElement('div');
  el.id = 'app-announcement-root';
  document.body.appendChild(el);

  const hostApp = createApp({
    render: () => h(AnnouncementModal),
  });
  hostApp.use(pinia);
  hostApp.use(i18n);
  hostApp.config.warnHandler = () => undefined;
  hostApp.mount(el);
  hostMounted = true;
}

/** 在 createApp 且 app.use(pinia / i18n) 之后调用 */
export function installAnnouncementModal(pinia: Pinia, i18n: Plugin): void {
  if (typeof document === 'undefined') return;
  const mount = () => ensureAnnouncementHost(pinia, i18n);
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount, { once: true });
}
